import { createContext } from 'react'

import { IS_DEVELOPMENT } from 'shared/consts'
import getComponentDisplayName from 'shared/utils/getComponentDisplayName'

export const SearchStateAndUrlContext = createContext({
  searchState: {},
  searchUrl: '',
  shouldShowVariantButtonsOnHits: true,
})

export const withSearchStateAndUrlContext = Component => {
  const WithSearchStateAndUrlContext = props => (
    <SearchStateAndUrlContext.Consumer>
      {searchStateAndUrl => <Component {...props} {...searchStateAndUrl} />}
    </SearchStateAndUrlContext.Consumer>
  )

  if (IS_DEVELOPMENT) {
    WithSearchStateAndUrlContext.displayName =
      getComponentDisplayName(Component)
  }

  return WithSearchStateAndUrlContext
}
